
<template>
   <el-dialog :title="textMap[title]" :visible.sync="dialogFormVisible"  width="30%">
    <el-form label-width="80px" :model="form" ref="form">
       <!-- <el-form-item label="上级部门" prop="parentId">
            <el-input disabled :placeholder="updataPlaceholder" readonly></el-input>
        </el-form-item> -->
        <el-form-item prop="name" label="部门名称">
            <el-input v-model="form.name"></el-input>
        </el-form-item>
      <!--  <el-form-item prop="orderNum" label="部门排序" :rules="[{ required: true, message: '请输入部门排序', trigger: 'blur'}]">
            <el-input v-model="form.orderNum"></el-input>
        </el-form-item> -->
         <el-form-item label="描述">
            <el-input v-model="form.tips" type="textarea" :rows="2" placeholder="请输入部门描述内容"></el-input>
        </el-form-item>
        <div style="display: flex;justify-content: flex-end;">
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="change_pwd('form')">提交</el-button>
        </div>
    </el-form>
</el-dialog>
</template>
<script>
import {getObj,addObj,putObj} from '@/api/admin/dept'
import {objKeySort} from '@/util/ajaxsign'
  export default {
    data() {
      return {
         title : '',
            textMap: {
                update: '编辑部门',
                create: '创建部门'
            },
            formEdit : 'true',
            updataPlaceholder:'',
            dictId : '',
            dialogFormVisible : false,
            form: {
                name: '',
                orderNum: '',
                parentId: '',
                deptId: '',
                tips : '',
            },
      };
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.dialogFormVisible = false;
        },

        onCancel() {
            this.formEdit = true
            this.formStatus = ''
            this.visible = false
        },

       //新增部门信息
        dialog(data,id,name){
            this.title = data;
            this.dialogFormVisible = true;
            this.form.parentId = id;
            this.updataPlaceholder = name?name:'顶级部门';
            this.form.orderNum = '';
            this.form.name = '';
            this.form.tips='';
        },
        //修改部门信息
        updialog(data,deptId,parentId,tips){
            this.title = data;
            this.dialogFormVisible = true;
            this.form.parentId = parentId;
            this.form.deptId = deptId;
            this.form.tips=tips
            this.getObj(parentId);
            this.getObjChild(deptId);
        },

        //获取父级部门名称
        getObj(data){
            getObj(objKeySort({id:data})).then(response => {
               // this.updataPlaceholder = response.data.data.name;
            })
        },
        //获取子部门信息
        getObjChild(data){
            getObj(objKeySort({id:data})).then(response => {
               this.form.name = response.data.data.name;
               this.form.orderNum = response.data.data.orderNum;
            })
        },

        // 修改弹窗
        handleUpdate(id) {
            let dicts = this.form.domains;
            dicts.length = 0;
            this.dictId = id;
            getObj(objKeySort({dictId:id})).then(response => {
                let dict = response.data.data;
                let dict1 = response.data.otherData;
                this.form.dictCode= dict.code;
                this.form.dictName= dict.name;
                this.form.dictTips= dict.tips;
                this.form.dictValues = " ";
                for(var di in dict1){
                    dicts.push({"value" : dict1[di].code,"value2" : dict1[di].name,"value3" : dict1[di].num})
                }
            })
        },

        handleEmpty(){
            this.$refs.form.resetForm();
            this.dialogFormVisible = false;
        },

        cancel(formName) {
           // this.dialogFormVisible = false;
            console.log(this.$refs[formName])
            this.$refs[formName].resetFields();
        },

        //处理数据
        change_pwd(data){
            if(this.title == "create"){
                this.addObj(data)
            }else{
                this.update(data)
            }
        },
        //创建部门
        addObj(formName) {
          let that=this
            if(that.form.name.trim()){
              var addDept = {name:that.form.name.trim(),orderNum:that.form.orderNum,parentId:that.form.parentId,tips:that.form.tips}
              addObj(objKeySort(addDept)).then(() => {
                  that.$message({
                      title: '成功',
                      message: '创建成功',
                      type: 'success',
                      duration: 2000
                  })
                  that.$emit("refresh");
                  that.dialogFormVisible = false;
              })
            }else{
              that.$message({
                  title: '温馨提示',
                  message: '部门名称必须填写',
                  type: 'warning',
                  duration: 2000
              })
            }
        },
        //修改
        update(formName) {
           let that=this
           if(that.form.name.trim()){
             var updataObj ={
                 deptId:that.form.deptId,
                 name:that.form.name.trim(),
                 orderNum:that.form.orderNum,
                 parentId:that.form.parentId,
                 tips:that.form.tips
             }
             putObj(objKeySort(updataObj)).then(() => {
                 that.$message({
                     title: '成功',
                     message: '更新成功',
                     type: 'success',
                     duration: 2000
                 })
                 that.$emit("refresh");
                 that.dialogFormVisible = false;
             })
           }else{
             that.$message({
                 title: '温馨提示',
                 message: '部门名称必须填写',
                 type: 'error',
                 duration: 2000
             })
           }
        },
    }
  }
</script>
